import "../../assets/Common.scss";
import "../../assets/fonts/font.css";
import React, { useEffect, useState } from "react";
import {
  moveToLogin,
  trackEvent,
  getChipsUid,
  openWebView,
  showBottomSheet,
  getInsetTop,
  calc,
  getInsetBottom,
} from "../../js/chips-common.js";
import chipsApi from "../../js/chips-api";
import Histories from "./component/Histories";
import reloadForChecksum from "../../util/ReloadChecksum";
import DateFormat from "../../util/DateFormat";

export default function VendingMachineHistory(props) {
  const dev = props.dev;
  const domain = dev
    ? `https://api.${dev}.chips.today`
    : "https://api.chips.today";

  const [drawOpportunityCount, setDrawOpportunityCount] = React.useState(0);
  const [histories, setHistories] = useState([]);
  const [missions, setMissions] = React.useState([]);

  useEffect(() => {
    window.moveToLogin = moveToLogin;

    try {
      // eslint-disable-next-line no-undef
      chipsApp.setThemeColor("#000000");

      // eslint-disable-next-line no-undef
      chipsApp.showHeader(false);

      // eslint-disable-next-line no-undef
      chipsApp.setFullscreen(true);
    } catch (e) {}

    refresh();
    reloadForChecksum();
  }, []);

  function refresh() {
    const now = new DateFormat().format("yyyy.MM.dd HH:mm:ss");
    if (now >= "2024.09.01 00:00:00") {
      try {
        showBottomSheet({
          icon: "https://cdn.chips.today/logic/images/2023/09/19/1695113982488-f687da0b-f2ef-4920-b2c6-d78ef7d5e582.png",
          title: "앗, 종료된 이벤트예요.",
          body: "다음 이벤트를 기대해 주세요!",
          secondary_button_text: "확인",
          secondary_button_style: "secondary",
          secondary_button_callback: "chipsApp.close()",
        });
      } catch (e) {}
      return;
    }
    if (getChipsUid()) {
      chipsApi.request({
        method: "get",
        url: `${domain}/api/v1/benefit-events/vending_machine/user/histories`,
        then: (response) => {
          const data = response.data;
          setDrawOpportunityCount(data.draw_opportunity_count);
          setHistories(data.benefit_event_user_histories);
        },
      });
    }

    getMissions();
  }

  function getMissions() {
    chipsApi.request({
      method: "get",
      url: `${domain}/api/v1/benefit-events/vending_machine`,
      then: (response) => {
        const data = response.data;
        setMissions(data.benefit_event_missions);
      },
    });
  }

  function onClickMission(mission) {
    if (mission) {
      trackEvent("mission_click", {
        id: mission.id.toString(),
        title: mission.name,
      });
    }

    try {
      if (mission?.popup) {
        // eslint-disable-next-line no-undef
        showBottomSheet({
          image: mission.popup.image_url,
          title: mission.popup.title,
          body: mission.popup.description,
          secondary_button_text: "닫기",
          primary_button_text: mission.popup.button_text,
          primary_button_style: "primary",
          primary_button_callback: `location.href="${mission.landing_url}"`,
        });
      } else {
        window.location.href = mission.landing_url;
      }
    } catch (e) {}
  }

  return (
    <div
      style={{
        background: "#FFF",
        width: calc(360),
        // height: "100vh",
        overflow: "hidden",
      }}
    >
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover"
      />

      <div
        className="scrollbar-hidden"
        style={{
          position: "relative",
          overflowY: "scroll",
          width: calc(360),
          bottom: 0,
        }}
      >
        <div
          style={{
            position: "fixed",
            top: calc(0, getInsetTop()),
            width: calc(360),
            zIndex: 2,
          }}
        >
          <div
            className="active-small"
            style={{
              position: "absolute",
              top: 0,
              left: calc(20),
              width: calc(36),
              height: calc(60),
              display: "flex",
              justifyContent: "center",
            }}
            onClick={() => {
              try {
                // eslint-disable-next-line no-undef
                chipsApp.close();
              } catch (e) {
                window.history.back();
              }
            }}
          >
            <img
              style={{
                width: calc(36),
                height: calc(36),
              }}
              src="https://cdn.chips.today/logic/images/2024/07/26/1721968137732-c646d8e5-c97b-4a9e-8c7b-b3c446ab1404.png"
            />
          </div>
        </div>

        <div
          style={{
            width: "100%",
            background: "#FFF",
          }}
        >
          <div
            style={{
              width: "100%",
              height: calc(213, getInsetTop()),
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                width: calc(360),
                height: calc(237, getInsetTop()),
              }}
            >
              <img
                src="https://cdn.chips.today/logic/images/2024/05/31/1717137782149-4a365a7f-c573-4ae7-8321-96a85fccd8db.png"
                style={{
                  width: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                marginTop: calc(100, getInsetTop()),
                width: "100%",
                boxSizing: "border-box",
                padding: `0 ${calc(20)}`,
                marginLeft: calc(20),
                background: "transparent",
              }}
            >
              <div
                style={{
                  marginLeft: calc(10),
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  gap: calc(0),
                  zIndex: 1,
                }}
              >
                <div
                  style={{
                    color: "#FFF",
                    fontFamily: "Gmarket Sans",
                    fontSize: calc(20),
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: calc(20),
                    letterSpacing: "-0.267px",
                  }}
                >
                  내가 구한 별
                </div>
                <div
                  style={{
                    marginTop: calc(4),
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    style={{
                      fontFamily: "Gmarket Sans",
                      fontSize: calc(40),
                      fontStyle: "normal",
                      fontWeight: 700,
                      lineHeight: calc(56),
                      color: "#FFF",
                    }}
                  >
                    {drawOpportunityCount}
                  </div>
                  <div
                    style={{
                      color: "#FFF",
                      fontFamily: "Gmarket Sans",
                      fontSize: calc(28),
                      fontWeight: 500,
                      marginLeft: calc(4),
                      marginTop: calc(11.26),
                    }}
                  >
                    개
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              width: calc(320),
              padding: `${calc(14)} ${calc(10)}`,
              justifyContent: "center",
              alignItems: "center",
              gap: calc(10),
              borderRadius: calc(6),
              background: "#F8F8F8",
              marginTop: calc(0),
              boxSizing: "border-box",
            }}
          >
            <span
              style={{
                color: "#2E2E2E",
                textAlign: "center",
                fontFamily: "Spoqa Han Sans Neo",
                fontSize: calc(12),
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: calc(18),
                letterSpacing: "-0.2px",
              }}
            >
              광고 미션 적립금에 따라 별을 구할 수 있어요
              <br />
              칩스 포인트{" "}
              <b>
                3,500원 <span style={{ color: "#5BCB2C" }}>‣</span> 별 350개
              </b>
            </span>
          </div>

          {histories && histories.length > 0 ? (
            <Histories histories={histories} />
          ) : (
            <div
              style={{
                display: "fixed",
                flexDirection: "column",
                marginTop: calc(14),
              }}
            >
              <img
                style={{
                  width: calc(274),
                  height: calc(158),
                  display: "inline-flex",
                  alignItems: "flex-start",
                }}
                src="https://cdn.chips.today/logic/images/2024/08/01/1722474456740-d9fa1d21-21ed-404e-81e0-1fb8f425c6ea.png"
              />

              <span
                style={{
                  color: "#212121",
                  textAlign: "center",
                  fontFamily: "Spoqa Han Sans Neo",
                  fontSize: calc(14),
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: calc(20),
                  letterSpacing: "-0.2px",
                  marginTop: calc(14),
                }}
              >
                구조를 기다리는 별이 아주 많아요!
              </span>
              <span
                style={{
                  color: "#9E9E9E",
                  textAlign: "center",
                  fontFamily: "Spoqa Han Sans Neo",
                  fontSize: calc(12),
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: calc(18),
                  letterSpacing: "-0.2px",
                  marginTop: calc(2),
                }}
              >
                별을 구해 포인트를 쌓으세요.
              </span>
            </div>
          )}

          <div
            style={{
              height: calc(
                120,
                `max(${calc(20)}, var(--safe-area-inset-bottom))`,
              ),
            }}
          ></div>

          <div
            className="active-only-alpha"
            style={{
              position: "fixed",
              bottom: 0,
              backgroundColor: "#6c00ff",
              width: calc(360),
            }}
            onClick={() => {
              const mission = missions.find((mission) => mission.type === "3");
              onClickMission(mission);
            }}
          >
            <img
              src="https://cdn.chips.today/logic/images/2024/07/29/1722232421758-6234251f-ab87-4b35-868e-6801ba4c58fb.png"
              style={{
                width: calc(360),
                height: calc(70),
                marginBottom: getInsetBottom(),
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
